import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getRidersMustBeMet } from '../api/services/Riders';
import { RiderMustBeMetResponse } from '../types/rider';

interface IUseRidersMustBeMetQuery {
  rideSlug: string;
  riderSlug: string;
}

export const useRidersMustBeMetQuery = ({ rideSlug, riderSlug }: IUseRidersMustBeMetQuery) => {
  return useApiGet<{ data: RiderMustBeMetResponse }>(
    ['ridersMustBeMet', riderSlug],
    () => getRidersMustBeMet({ rideSlug: rideSlug, riderSlug: riderSlug }),
    {
      enabled: true,
    }
  );
};
